module cr.entity
{

    export class EntityListTreeNode implements ITreeNode {
        constructor(public entityService:IEntityService, public definition:EntityDefinitionView,public moduleDetail:EntityModule,public relation?:any) {
            this.id = definition.Name;

            this.nodes = [];
        }

        TreeManager:entity.ITreeManager;
        id:string;

        collapsed:boolean;
        displayName(){
            return angular.isDefined(this.relation)?this.relation.DisplayName: this.definition.DisplayName;
        }
        parent:entity.ITreeNode;
        nodes:Array<entity.ITreeNode>;

        GetPath= ()=>
        {
            //console.log("getpath? "+angular.isFunction((<any>parent).GetPath)+" / "+parent.nodeType());
            //console.log((<any>this.parent).GetPath);

            if (this.parent!=null && angular.isFunction((<any>this.parent).GetPath))
            {
                console.log("parent path: "+(<any>this.parent).GetPath());
                return (<any>this.parent).GetPath()+","+this.relation.Name;
            }

            console.log("cool ici");
            return this.moduleDetail.Name+","+this.definition.Name;
        }

        nodeType=()=>"EntityList";

        Create() {
            this.Action("expand");

            console.log("create");
            var child=_.find(this.nodes,n=>(<any>n).entity==null || (<any>n).entity.Id=="0");

            if (!child){
                // check if we already have a node in the tree to create a new entity


                //create(fullPath:string): angular.IPromise<any>
                this.entityService.create(this.GetPath()).then(newEntity=>{

                    child=new EntityNode(this.entityService, this.definition,this.moduleDetail,newEntity);
                    this.TreeManager.AddNode(child,this);
                    child.Action("click");
                });

            }
            else child.Action("click");
        }


        ShowEntity(entity:any){
            this.Action("expand");

            /*for (var node in this.nodes)
            {
                var child=<any>this.nodes[node];

                if (child.entity.Id==entity.Id)
                {
                    child.entity=entity;
                    child.Action("click");
                    return;
                }
            }*/


            this.nodes=_.reject(this.nodes,n=>(<any>n).entity.Id==entity.Id);

            var toAdd=new EntityNode(this.entityService, this.definition,this.moduleDetail,entity);
            this.TreeManager.AddNode(toAdd,this);
            toAdd.Action("click");
        }

        Action(eventName:string, args?:any) {
            //console.log("we received an event: " + eventName + " [" + this.definition.DisplayName + "]");
            switch (eventName) {
                case "click":
                    //this.nodes.push(new NodeBase("Click","clk"+this.nodes.length,this));
                    this.TreeManager.SetContent("cr-entity-list", this, this.id);

                    break;
            }
        }
    }

    class EntityListCtrl {

        treeNode:EntityListTreeNode;

        Search=(value:string)=>{
            console.log("We search... "+this.treeNode.moduleDetail.Name+this.treeNode.GetPath()+" - "+value);

            console.log("relation: "+angular.toJson(this.treeNode.relation));
            if (angular.isDefined((<any>this.treeNode.parent).entity)) console.log("parent: "+angular.toJson((<any>this.treeNode.parent).entity.Id));

            this.entityService.search(this.treeNode.GetPath(), value).then((result:DynamicTable)=> {
              //  console.log("search result:"+angular.toJson(result));
                if (!result){
                    this.$scope.result={ Rows:[] };
                }
                else this.$scope.result = result;
            });

        }

        SelectEntity=(action:string,data:any)=>
        {
            //console.log("action: "+action);
            //console.log("data: "+angular.toJson(data));
            this.entityService.getEntity(this.treeNode.moduleDetail.Name,this.treeNode.definition.Name,data.Id).then((entity:any)=>{
              // console.log("got entity from: "+angular.toJson(entity));

                this.treeNode.ShowEntity(entity);
            });
        }

        constructor(private $scope,private entityService:IEntityService){
            //EntityListTreeNode listTreeNode=<EntityListTreeNode>

            $scope.Create=()=>this.treeNode.Create();

            $scope.Search=this.Search;
            $scope.SelectEntity=this.SelectEntity;

            $scope.$watch('tree.currentNode.id',(val)=>{
                console.log('Current tree node changed: '+val);
                this.treeNode=<EntityListTreeNode>$scope.tree.currentNode;
                this.$scope.search='';

                $scope.path=this.treeNode.GetPath();

                $scope.result='';
            });
        }
    }

    entityModule.directive('crEntityList', function () {
        return {
            restrict: "E",
            scope: true,
            templateUrl: "modules/entity/views/entitylist.html",
            require: "^crTreeViewer",
            link: function (scope, element, attrs, treeViewer) {
                scope.treeViewer = treeViewer;
                scope.tree = treeViewer.getTree();


                scope.$on("$destroy",function(){
                    console.log("destroy list");
                });

            },
            controller: ['$scope','entityService',EntityListCtrl]
        }
    });

}
